import { render, staticRenderFns } from "./ChartjsBarChart4.vue?vue&type=template&id=1ee6b045&scoped=true&"
import script from "./ChartjsBarChart4.vue?vue&type=script&lang=js&"
export * from "./ChartjsBarChart4.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsBarChart4.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChartjsBarChart4.vue?vue&type=style&index=1&id=1ee6b045&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee6b045",
  null
  
)

export default component.exports